<template lang="pug">
  //- Alerts List
  ods-table(:data='table')
    ods-table-column(
      prop='level'
      :label='$t("nivel")'
      :sortable="true"
      width='90'
    )
      template(slot-scope="scope")
        div.sc-dashboard__level
          template(v-if="alert")
            template(v-if="scope.row.level === 'high'")
              ods-tooltip(content="Alerta importante" placement="top")
                div.table-dot(class="table-dot--danger")
            template(v-else-if="scope.row.level === 'medium'")
              ods-tooltip(content="Alerta moderada" placement="top")
                div.table-dot(class="table-dot--medium")
            template(v-else-if="scope.row.level === 'low'")
              ods-tooltip(content="Alerta baja" placement="top")
                div.table-dot(class="table-dot--warning")
            template(v-else)
              ods-tooltip(content="Alerta importante" placement="top")
                div.table-dot
          template(v-if="campaign")
            div.sc-dashboard__level__circle
              span {{ scope.row.level }}
    ods-table-column(
      prop='icon'
      :label='$t("area")'
      :sortable="true"
      width='70'
    )
      template(slot-scope="scope")
        div.custom-icon
          i(:class='scope.row.icon')
        //- <app-icon-svg :icon="scope.row.icon"></app-icon-svg>
        //- ods-icon(name="control" size="18")
    ods-table-column(v-if="alert" :formatter="formatHour" prop='hour' :label='$t("hora")' :sortable="true" width='80')
    //-  == 'Dashboard'
    ods-table-column.align-left(v-if="$route.name == 'Dashboard'" prop='name' :label='$t("titulo")' :sortable="true" min-width="140")
    ods-table-column(v-if="campaign && $route.name == 'Dashboard'" prop='period' :label='$t("periodo")' :sortable="true" min-width='175')
    //-  !== 'Dashboard'
    ods-table-column.align-left(v-if="$route.name !== 'Dashboard'" prop='name' :label='$t("titulo")' :sortable="true" min-width="170")
    ods-table-column(v-if="campaign && $route.name !== 'Dashboard'" prop='period' :label='$t("periodo")' :sortable="true" min-width='150')
    ods-table-column(
      v-if="link"
      prop='id'
      width='50'
    )
      template(slot-scope="scope")
        ods-icon.detail-icon(
          @click.native="showDetail(scope.row)"
          name="arrow-right"
          size="18")
</template>

<script>
import IconSvg from '@/components/IconSvg'
import mapElements from '@/mixins/mapElements'
export default {
  name: 'AlertsList',
  mixins: [ mapElements ],
  props: {
    dataTable: {
      type: Array
    },
    alert: {
      type: Boolean
    },
    campaign: {
      type: Boolean
    },
    link: {
      type: Boolean
    },
    height: {
      type: String
    }
  },
  data () {
    return {
      table: [ ]
    }
  },
  watch: {
    dataTable (newVal, oldVal) {
      const component = this
      component.table = newVal
    }
  },

  methods: {
    formatHour (row, column, cellValue, index) {
      return this.formatLocaleHour(row.date)
    },
    shortenDescription (row, column, cellValue, index) {
      if (cellValue.length > 80) {
        return cellValue.substring(0, 80) + '...'
      } else {
        return cellValue
      }
    },
    showDetail (data) {
      const component = this
      var obj = {
        list: component.dataTable,
        selected: data
      }
      this.$emit('detailSelect', obj)
    },
    changeAlertToday (data) {
      this.alertsToday = data
    }
  },

  components: {
    appIconSvg: IconSvg
  },

  created () {
    this.table = this.dataTable
  }
}
</script>

<style lang="scss" scoped>

.sc-dashboard{
  &__level {
    display: flex;
    justify-content: center;
    &__circle {
      align-items: center;
      border-radius: 50%;
      border: 1px solid $--color-primary;
      color: $--color-primary;
      display: flex;
      height: rem(25);
      justify-content: center;
      width: rem(25);
      + .sc-modal__status {
        margin-left: rem(15.5)
      }
      span{
        line-height: 1.1;
      }
    }
  }

  /deep/ .ods-tabs__header{
    margin-bottom: rem(32);
  }
  /deep/ .ods-tabs__nav-scroll{
    padding: 0 rem(32);
  }
  /deep/ .ods-date-editor.ods-input {
    width: rem(125);
  }
}

.detail-icon{
  cursor: pointer;
}

.ods-table .cell {
  padding: 0 rem(10);
}
</style>



// WEBPACK FOOTER //
// src/components/AlertsAndCampaignList.vue